"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _slider = require("baseui/slider");

var _reactVis = require("react-vis");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HexHeatmap = function (_Component) {
  _inherits(HexHeatmap, _Component);

  var _super = _createSuper(HexHeatmap);

  function HexHeatmap() {
    var _this;

    _classCallCheck(this, HexHeatmap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hoveredNode: null,
      radius: 10,
      offset: 0
    });

    return _this;
  }

  _createClass(HexHeatmap, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          options = _this$props.options;
      var radius = this.state.radius;
      if (!data || !data.length) return null;
      return _react["default"].createElement("div", {
        className: "centered-and-flexed",
        style: {
          color: '#fff'
        }
      }, _react["default"].createElement(_slider.Slider, {
        value: [this.state.radius],
        min: 5,
        max: 50,
        step: 5,
        onChange: function onChange(_ref) {
          var value = _ref.value;

          _this2.setState({
            radius: value[0]
          });
        }
      }), "Radius (pixels)", _react["default"].createElement(_reactVis.XYPlot, {
        margin: {
          left: 10,
          bottom: 10
        },
        height: options && options.plotStyle && options.plotStyle.height || 350,
        width: options && options.plotStyle && options.plotStyle.width || 350,
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            hoveredNode: null
          });
        }
      }, _react["default"].createElement(_reactVis.HexbinSeries, {
        animation: true,
        className: "hexbin-example",
        style: {
          stroke: '#125C77',
          strokeLinejoin: 'round'
        },
        colorRange: ['orange', 'cyan'],
        radius: radius,
        data: data
      }), options && !options.noXAxis && _react["default"].createElement(_reactVis.XAxis, {
        tickLabelAngle: -45,
        style: {
          text: {
            fill: '#fff',
            fontWeight: 400
          }
        }
      }), options && !options.noYAxis && _react["default"].createElement(_reactVis.YAxis, {
        tickLabelAngle: -45,
        style: {
          text: {
            fill: '#fff',
            fontWeight: 400
          }
        }
      })));
    }
  }]);

  return HexHeatmap;
}(_react.Component);

exports["default"] = HexHeatmap;